import translations from './tantalum.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/tantalum'

export const tantalum: Metal = {
  id: 32,
  slug: 'tantalum',
  name: t.name,
  symbol: 'Ta',
  // The sheet's eight pins replace the four grouped placeholders: the three DRC
  // provinces and the three Rwandan sites are now separate, Minas Gerais stands in for
  // the AMG operation inside it, and Marble Bar replaces Wodgina. No operators — the
  // sheet names none. Four of the eight are provinces or a state rather than a mine, so
  // their coordinates are the administrative centre, not a pit head. Nigeria has no pin
  // even though the sheet puts it second at 19.1%.
  mines: [
    {
      name: 'Maniema (DRC)',
      region: 'Maniema',
      coordinates: [25.95, -2.95],
    },
    {
      name: 'North Kivu (DRC)',
      region: 'North Kivu',
      coordinates: [29.0, -0.7],
    },
    {
      name: 'South Kivu (DRC)',
      region: 'South Kivu',
      coordinates: [28.2, -3.0],
    },
    {
      name: 'Ngoma (Rwanda)',
      region: 'Ngoma',
      coordinates: [30.47, -2.19],
    },
    {
      name: 'Gatumba (Rwanda)',
      region: 'Gatumba',
      coordinates: [29.6, -1.87],
    },
    {
      name: 'Musha (Rwanda)',
      region: 'Musha',
      coordinates: [30.28, -1.93],
    },
    {
      name: 'Minas Gerais (Brazil)',
      region: 'Minas Gerais',
      coordinates: [-44.5, -18.5],
    },
    {
      name: 'Marble Bar (Australia)',
      region: 'Marble Bar',
      coordinates: [119.75, -21.17],
    },
  ],
  countries: [
    { name: 'DRC', percent: 45.1 },
    { name: 'Nigeria', percent: 19.1 },
    { name: 'Rwanda', percent: 17.2 },
    { name: 'Brazil', percent: 6.8 },
    { name: 'China', percent: 3.8 },
  ],
  important: true,
  // The sheet's three, in its order: the rest of the 3TG conflict minerals. Tin's sheet
  // names tantalum back, and gold's names all three, so the grouping is reciprocal.
  related: ['tin', 'gold', 'tungsten'],
  video: {
    name: 'tantalum',
    poster: '/mine-my-phone/images/posters/tantalum.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 3, ...t.impacts.human },
      geopolitical: { severity: 4, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
        credit: 'David Maenda Kithoko',
      },
      firstBento: [
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'David Maenda Kithoko',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'vertical',
          credit: 'David Maenda Kithoko',
        },
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
          credit: 'Tom Stoddart / Getty',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'horizontal',
          credit: 'David Maenda Kithoko',
        },
      ],
    },
  },
}
